import { createWebHistory, createRouter } from "vue-router";
import Chat from '../components/ChatWrapper';
import SignIn from '../components/SignIn';
import SignUp from "../components/SignUp";
import store from '../store';
import PasswordReset from "../components/PasswordReset";
import PasswordResetConfirm from "../components/PasswordResetConfirm";


const requireAuthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (!store.getters['auth/isAuthenticated']) {
        next('/login');
      } else {
        next();
      }
    });
};

const requireUnauthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (store.getters['auth/isAuthenticated']) {
        next('/');
      } else {
        next();
      }
    });
};

const redirectLogout = (to, from, next) => {
  store.dispatch('auth/logout')
    .then(() => next('/'));
};


const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'Chat', component: Chat, beforeEnter: requireAuthenticated },

    { path: '/login', name: 'SignIn', component: SignIn, beforeEnter: requireUnauthenticated },
    { path: '/signup', name: 'SignUp', component: SignUp, beforeEnter: requireUnauthenticated },
    { path: '/password_reset', name: 'PasswordReset', component: PasswordReset, },
    { path: '/password_reset/:uid/:token', name: 'PasswordResetConfirm', component: PasswordResetConfirm, },
  ]
})

export default router
